import React from 'react';

import Helmet from 'wanderu-component-helmet';
import { localize } from 'wanderu-i18n';

import socialThumbnailLocation from 'wanderu-assets/images/explorebywanderu-social.png';

import localesConfig from '../../../config/explorer.locales';

function ExplorerMeta(props) {
    const {
        i18nMoney,
        t,
        ...otherProps
    } = props;
    const title = `${t('explore-by-wanderu')} | ${t('bus-and-train-tickets-from-your-city')}`;
    const description = `${t('get-inspired-to-travel-cheap-and-explore')} ${t('find-bus-and-train-ticket-deals-from-your-city-starting-at', {
        oneDollar: i18nMoney(1, 'USD').setCurrency('USD').format(),
    })}`;

    return (
        <Helmet
            {...otherProps}
            description={description}
            image={{
                src: socialThumbnailLocation,
                height: 1047,
                width: 2000,
            }}
            supportedLocales={localesConfig.supportedLocales}
            title={title}
        />
    );
}

export { ExplorerMeta };
export default localize(ExplorerMeta, ['i18nMoney', 't'], localesConfig.namespace);
